import { OptionType } from "components/UI/CustomSelect";
import { Pallete } from "components/UI/Icons";
import { PalletRow } from "models/packingList";

export const PALLET_TYPE = {
  EU_PALLETS: "eu-pallets",
  EU_HALF_PALLETS: "eu-1-2-pallets",
  EU_PLASTIC_PALLETS: "eu-plastic-pallets",
  US_PALLETS: "us-pallets",
  CUSTOM_PALLETS: "custom-pallets",
} as const;

export const PALLET_PRESETS: Record<string, Pick<PalletRow, "length" | "width" | "height" | "depth" | "maxWeight">> = {
  "eu-pallets": { length: 1200, width: 800, height: 2000, depth: 100, maxWeight: 1500 },
  "eu-1-2-pallets": { length: 600, width: 800, height: 2000, depth: 100, maxWeight: 1300 },
  "eu-plastic-pallets": { length: 1200, width: 800, height: 2000, depth: 100, maxWeight: 1300 },
  "us-pallets": { length: 1200, width: 1000, height: 2000, depth: 100, maxWeight: 750 },
};

export const DEFAULT_PALLET_OPTIONS: OptionType[] = [
  { value: "eu-pallets", label: "Europe pallets", valueIcon: <Pallete /> },
  { value: "eu-1-2-pallets", label: "Europe 1/2 pallets", valueIcon: <Pallete /> },
  { value: "eu-plastic-pallets", label: "Europe plastic pallets", valueIcon: <Pallete /> },
  { value: "us-pallets", label: "US pallets", valueIcon: <Pallete /> },
  { value: "custom-pallets", label: "Custom pallets", valueIcon: <Pallete /> },
];
